import { render, staticRenderFns } from "./RetailerCardView.vue?vue&type=template&id=1e9709d6&lang=pug"
import script from "./RetailerCardView.vue?vue&type=script&lang=js"
export * from "./RetailerCardView.vue?vue&type=script&lang=js"
import style0 from "./RetailerCardView.vue?vue&type=style&index=0&id=1e9709d6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports